const HIJRI_MONTHS = [
  'Muharram', 'Safar', 'Rabiʻ I', 'Rabiʻ II',
  'Jumada I', 'Jumada II', 'Rajab', "Sha'ban",
  'Ramadan', 'Shawwal', "Dhuʻl-Qiʻdah", 'Dhuʻl-Hijjah'
];

const GREGORIAN_MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

// Kuwaiti algorithm for Gregorian to Hijri conversion
function gregorianToHijri(date: Date): { day: number; month: string; year: string } {
  const jdn = Math.floor((date.getTime() / 86400000) + 2440588);
  const l = jdn - 1948440 + 10632;
  const n = Math.floor((l - 1) / 10631);
  const l2 = l - 10631 * n + 354;
  const j = Math.floor((10985 - l2) / 5316) * Math.floor((50 * l2) / 17719)
    + Math.floor(l2 / 5670) * Math.floor((43 * l2) / 15238);
  const l3 = l2 - Math.floor((30 - j) / 15) * Math.floor((17719 * j) / 50)
    - Math.floor(j / 16) * Math.floor((15238 * j) / 43) + 29;
  const hm = Math.floor((24 * l3) / 709);
  const hd = l3 - Math.floor((709 * hm) / 24);
  const hy = 30 * n + j - 30;

  return { day: hd, month: HIJRI_MONTHS[hm - 1] || 'Month', year: String(hy) };
}

export function getHijriDate(date: Date, adjustment: number = 0): { day: number; month: string; year: string } {
  const adjusted = new Date(date);
  adjusted.setDate(adjusted.getDate() + adjustment);
  try {
    const formatter = new Intl.DateTimeFormat('en-u-ca-islamic', { day: 'numeric', month: 'long', year: 'numeric' });
    const parts = formatter.formatToParts(adjusted);
    const month = parts.find(p => p.type === 'month')?.value || '';
    const year = parts.find(p => p.type === 'year')?.value || '';
    const day = parseInt(parts.find(p => p.type === 'day')?.value || '0');
    if (month && !GREGORIAN_MONTHS.includes(month) && parseInt(year) > 1400) {
      return { day, month, year };
    }
  } catch (e) { /* fallback below */ }
  return gregorianToHijri(adjusted);
}

export function formatHijriDate(date: Date, adjustment: number = 0): string {
  const { day, month, year } = getHijriDate(date, adjustment);
  return `${day} ${month} ${year}`;
}

export { HIJRI_MONTHS, GREGORIAN_MONTHS, gregorianToHijri };
